<form class="w-100 h-100 form" [formGroup]="titleForm" (ngSubmit)="sendData()">
  <h4 class="text-center">Editar título de sección</h4>
  <div class="row mx-0 my-3 p-0 w-100">
    <div class="col-12">
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Título</mat-label>
        <input matInput placeholder="Texto de botón" formControlName="name">
        <mat-error>Este campo es <b>Requerido</b></mat-error>
      </mat-form-field>
    </div>
  </div>


  <button class="vs-btn-blue btn-section" type="submit" [disabled]="titleForm.invalid">
    Guardar
  </button>
</form>

